<template>
<div class="chapter">
<div class="inner_page">
<p class="book-pages---regular"><span class="charoverride"><br class="calibre1"/></span></p>
<h1 class="book-pages---regular"><span class="charoverride">Dedication</span></h1>
<div class="basic-text-frame" id="_idContainer005">
<p class="book-list-no-italic"><em class="italic"><br class="calibre1"/></em></p>
<p class="book-list-no-italic"><em class="italic">This book is for Michael Warby,<br class="calibre2"/>peerless researcher, dear friend, il magnifico</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?76dd3872